const coin = ["heads", "tails"];
const d4 = [1, 2, 3, 4];
const d6 = [1, 2, 3, 4, 5, 6];
const d8 = [1, 2, 3, 4, 5, 6, 7, 8];
const d10 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
const d12 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const d20 = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
];
const d100 = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80,
  81,
  82,
  83,
  84,
  85,
  86,
  87,
  88,
  89,
  90,
  91,
  92,
  93,
  94,
  95,
  96,
  97,
  98,
  99,
  100,
];
// const d100 = [
//   0,
//   0,
//   0,
//   0,
//   0,
//   0,
//   0,
//   0,
//   0,
//   0,
//   10,
//   10,
//   10,
//   10,
//   10,
//   10,
//   10,
//   10,
//   10,
//   20,
//   20,
//   20,
//   20,
//   20,
//   20,
//   20,
//   20,
//   20,
//   30,
//   30,
//   30,
//   30,
//   30,
//   30,
//   30,
//   30,
//   30,
//   40,
//   40,
//   40,
//   40,
//   40,
//   40,
//   40,
//   40,
//   40,
//   50,
//   50,
//   50,
//   50,
//   50,
//   50,
//   50,
//   50,
//   50,
//   60,
//   60,
//   60,
//   60,
//   60,
//   60,
//   60,
//   60,
//   60,
//   70,
//   70,
//   70,
//   70,
//   70,
//   70,
//   70,
//   70,
//   70,
//   80,
//   80,
//   80,
//   80,
//   80,
//   80,
//   80,
//   80,
//   80,
//   90,
//   90,
//   90,
//   90,
//   90,
//   90,
//   90,
//   90,
//   90,
//   "00",
//   "00",
//   "00",
//   "00",
//   "00",
//   "00",
//   "00",
//   "00",
//   "00",
// ];
const d120 = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80,
  81,
  82,
  83,
  84,
  85,
  86,
  87,
  88,
  89,
  90,
  91,
  92,
  93,
  94,
  95,
  96,
  97,
  98,
  99,
  100,
  101,
  102,
  103,
  104,
  105,
  106,
  107,
  108,
  109,
  110,
  111,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  120,
];

module.exports = {
  coin,
  d4,
  d6,
  d8,
  d10,
  d12,
  d20,
  d100,
  d120,
};
